import { render, staticRenderFns } from "./VariantSifterGlobalEnrichmentDrawer.vue?vue&type=template&id=80e41de2&scoped=true&"
import script from "./VariantSifterGlobalEnrichmentDrawer.vue?vue&type=script&lang=js&"
export * from "./VariantSifterGlobalEnrichmentDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterGlobalEnrichmentDrawer.vue?vue&type=style&index=0&id=80e41de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e41de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e41de2')) {
      api.createRecord('80e41de2', component.options)
    } else {
      api.reload('80e41de2', component.options)
    }
    module.hot.accept("./VariantSifterGlobalEnrichmentDrawer.vue?vue&type=template&id=80e41de2&scoped=true&", function () {
      api.rerender('80e41de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterGlobalEnrichmentDrawer.vue"
export default component.exports